module.exports = __webpack_public_path__ + "media/images/flags/1x1/sxm-68af5a9d09a2d9f92ece488e80397484.svg";